import React, { useEffect, useState } from "react";
import "./SysAdminDashboard.css";
import {
  Bar,
  HorizontalBar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
} from "react-chartjs-2";
import GoogleMapReact from "google-map-react";
import axios from "axios";
import { environment } from "../../environment";
import Select from "react-select";
import { Form, Button } from "react-bootstrap";

const SysAdminDashboard = () => {
  const [activeNav, setactiveNav] = useState("");
  const [key, setKey] = useState("nav-link0");

  const [LocationDropDown, setLocationDropDown] = useState([
    { label: "All Locations", value: "", deviceCount: 0 },
  ]);
  const [Total, setTotal] = useState("");
  const [InStock, setInStock] = useState("");
  const [inTransit, setinTransit] = useState("");
  const [Active, setActive] = useState("");
  const [Damaged, setDamaged] = useState("");

  const [Date, setDate] = useState("this-week");
  const [CurrentToggleDate, SetCurrentToggleDate] = useState("This Week");
  const [Location, setLocation] = useState({});
  const [IV, setIV] = useState("");

  //CRM
  const [CRMLabel, setCRMLabel] = useState([""]);
  const [CRMConverted, setCRMConverted] = useState([""]);
  const [CRMLeads, setCRMLeads] = useState([""]);

  //IV
  const [IVData, setIVData] = useState([""]);

  //Support
  const [SupportAssigned, setSupportAssigned] = useState([]);
  const [SupportSolved, setSupportSolved] = useState([]);
  const [SupportPending, setSupportPending] = useState([]);
  const [SupportInProgress, setSupportInProgress] = useState([]);
  const [SupportHold, setSupportHold] = useState([]);

  const [CUSTOMER, setCUSTOMER] = useState([]);

  //ShipmentStatus
  const [ShipmentStatus, setShipmentStatus] = useState([""]);

  const [fname, setFname] = useState("");
  const [SupportTicketAll, setSupportTicketAll] = useState([""]);
  const [SupportTicketAssigned, setSupportTicketAssigned] = useState([""]);
  const [SupportTicketPending, setSupportTicketPending] = useState([""]);
  const [SupportTicketSolved, setSupportTicketSolved] = useState([""]);
  const [SupportTicketEscalation, setSupportTicketEscalation] = useState([""]);

  useEffect(() => {
    let uid = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(environment.dap_url + "users/getUserById?id=" + uid)
      .then((resp) => {
        let user = resp.data.note;
        console.log("navbar", resp.data);
        let user_name = user.userFirstName;
        setFname(user_name);
      });
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    LocationSelector();
    setLocation(LocationDropDown[0]);
    getOverViewData(
      Date,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getCRMData(Date, Location.value != undefined ? Location.value : "", IV);
    getIVData(Date, Location.value != undefined ? Location.value : "", IV);
    getSupportData(Date, Location.value != undefined ? Location.value : "", IV);
    getCustomerData(
      Date,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getShipmentStatus(Date, "", "");
    GetSupportTickets(Date);
    GetSupportEscalation(Date);
  }, []);

  const GetDate = (event) => {
    setDate(event.target.value);
    SetCurrentToggleDate(
      event.target.options[event.target.selectedIndex].innerHTML
    );
    getOverViewData(
      event.target.value,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getCRMData(
      event.target.value,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getIVData(
      event.target.value,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getSupportData(
      event.target.value,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getCustomerData(
      event.target.value,
      Location.value != undefined ? Location.value : "",
      IV
    );
    getShipmentStatus(event.target.value, "", "");
    GetSupportTickets(event.target.value);
    GetSupportEscalation(event.target.value);
  };

  const LocationSelector = () => {
    axios
      .get(environment.dap_url + "dashboardApi/getActiveDeviceLocation")
      .then((res) => {
        console.log(res.data);
        let LocationArr = [];
        // LocationArr.push({ _id: "", deviceCount: 0 });

        let locArr = [...LocationDropDown];
        for (let i = 0; i < res.data.length; i++) {
          // LocationArr.push(res.data[i]._id);
          locArr.push({
            label: res.data[i]._id,
            value: res.data[i]._id,
            deviceCount: res.data[i].deviceCount,
          });
        }
        // setLocationDropDown()
        console.log(LocationArr);
        setLocationDropDown(locArr);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const GetLocation = (event) => {
    setLocation({ label: event.label, value: event.value });
    getOverViewData(Date, event.value, IV);
    getCRMData(Date, event.value, IV);
    getIVData(Date, event.value, IV);
    getSupportData(Date, event.value, IV);
    getCustomerData(Date, event.value, IV);
    getShipmentStatus(Date, "", "");
  };

  const chooseIV = (event) => {
    console.log(event.target.value);
    setIV(event.target.value);
    getOverViewData(
      Date,
      Location.value != undefined ? Location.value : "",
      event.target.value
    );
    getCRMData(
      Date,
      Location.value != undefined ? Location.value : "",
      event.target.value
    );
    getIVData(
      Date,
      Location.value != undefined ? Location.value : "",
      event.target.value
    );
    getSupportData(
      Date,
      Location.value != undefined ? Location.value : "",
      event.target.value
    );
    getCustomerData(
      Date,
      Location.value != undefined ? Location.value : "",
      event.target.value
    );
    getShipmentStatus(Date, "", "");
  };
  const getOverViewData = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/device_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log(res.data);
        setTotal(res.data.totalDevices);
        setInStock(res.data.inStock);
        setinTransit(res.data.inTransit);
        setActive(res.data.active);
        setDamaged(res.data.damaged);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const getCRMData = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/crm_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("CRM_Data", res.data);
        let Label = [];
        let Converted = [];
        let Leads = [];
        for (let i = 0; i < res.data.length; i++) {
          Converted.push(res.data[i].customer);
          Leads.push(res.data[i].leads);
          Label.push(res.data[i].label);
        }

        setCRMConverted(Converted);
        setCRMLeads(Leads);
        setCRMLabel(Label);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const CRMdata = {
    labels: CRMLabel,
    datasets: [
      {
        label: "Leads",
        data: CRMLeads,
        backgroundColor: "#E14D2A",
      },
      {
        label: "Converted",
        data: CRMConverted,
        backgroundColor: "#2EB086",
      },
    ],
  };

  const getIVData = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/industry_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        let IVArr = [];
        console.log("IV_overview", res.data);
        IVArr.push(res.data.healthcare);
        IVArr.push(res.data.hospitality);
        IVArr.push(res.data.educational);
        IVArr.push(res.data.corporate);
        IVArr.push(res.data.manufacturing);
        IVArr.push(res.data.others);

        setIVData(IVArr);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const IVdata = {
    labels: [
      "Healthcare",
      "Hospitality",
      "Educational",
      "Corporate",
      "Manufacturing Unit",
      "Others",
    ],
    datasets: [
      {
        label: "Industry Verticals",
        data: IVData,
        backgroundColor: [
          "#00B8A9",
          "#FFBF00",
          "#FF7000",
          "#540375",
          "#CE7777",
          "#baba44",
        ],
      },
    ],
  };

  const getSupportData = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/support_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("Support data", res.data);

        let Assigned = [];
        let Solved = [];
        let Pending = [];
        let InProgress = [];
        let Hold = [];

        for (let i = 0; i < res.data.length; i++) {
          Assigned.push(res.data[i].tickets.assigned);
          Solved.push(res.data[i].tickets.solved);
          Pending.push(res.data[i].tickets.pending);
          InProgress.push(res.data[i].tickets.inprogress);
          Hold.push(res.data[i].tickets.hold);
        }
        setSupportAssigned(Assigned.reverse());
        setSupportSolved(Solved.reverse());
        setSupportPending(Pending.reverse());
        setSupportInProgress(InProgress.reverse());
        setSupportHold(Hold.reverse());
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const SupportBarData = {
    labels: ["High", "Medium", "Low"],
    datasets: [
      {
        label: "Pending",
        backgroundColor: "#FDAE38",
        // borderColor: "rgba(54,162,235,1)",
        borderWidth: 1,
        data: SupportPending,
      },
      {
        label: "Assigned",
        backgroundColor: "#684C41",
        // borderColor: "rgba(255,99,132,1)",
        borderWidth: 1,
        data: SupportAssigned,
      },
      {
        label: "Hold",
        backgroundColor: "#F75435",
        // borderColor: "rgba(255,99,132,1)",
        borderWidth: 1,
        data: SupportHold,
      },
      {
        label: "In Progress",
        backgroundColor: "#00B252",
        // borderColor: "rgba(54,162,235,1)",
        borderWidth: 1,
        data: SupportInProgress,
      },
      {
        label: "Solved",
        backgroundColor: "#00B8A9",
        // borderColor: "rgba(54,162,235,1)",
        borderWidth: 1,
        data: SupportSolved,
      },
    ],
  };

  const SupportBaroptions = {
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            stepSize: 1,
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          gridLines: {
            zeroLineWidth: 1,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: "Priority Level",
            fontColor: "#333333",
            fontFamily: "Roboto",
            fontSize: 14,
            fontWeight: 900,
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      labels: {
        usePointStyle: false, // Enables the use of point-style marker
        boxWidth: 10, // Adjust the size of the marker
        fontSize: 13, // Change the font size of the legend text
      },
      position: "bottom",
    },
  };
  const getCustomerData = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/customer_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("Customer", res.data);
        setCUSTOMER(res.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const getShipmentStatus = (d, loc, ind) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/shipment_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        let ShipmentStatusdata = [];
        console.log("Shipment Status", res.data);
        ShipmentStatusdata.push(res.data.readyToShip);
        ShipmentStatusdata.push(res.data.inTransit);
        ShipmentStatusdata.push(res.data.delivered);
        setShipmentStatus(ShipmentStatusdata);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const ShipmentStatusData = {
    labels: ["Ready To Ship", "In Transit", "Delivered"],
    datasets: [
      {
        label: "Shipment Status",
        data: ShipmentStatus,
        backgroundColor: ["#E6B566", "#6867AC", "#29CC39"],
      },
    ],
  };

  const GetSupportTickets = (d) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "support/supportTicket?id=" +
          userId +
          "&date=" +
          d
      )
      .then((res) => {
        console.log("SupportTicketData", res.data);
        setSupportTicketAll(res.data.all);
        setSupportTicketAssigned(res.data.assigned);
        setSupportTicketPending(res.data.pending);
        setSupportTicketSolved(res.data.solved);
      });
  };

  const GetSupportEscalation = (d) => {
    let userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .get(
        environment.dap_url +
          "support/supportTicketEscalation?id=" +
          userId +
          "&date=" +
          d
      )
      .then((res) => {
        console.log("Escalation", res.data.escalation);
        setSupportTicketEscalation(res.data.escalation);
      });
  };

  const handelClick = (event) => {
    // for the navbar toggle only
    const nav_tab = document.getElementsByName("tabs");
    nav_tab.forEach((link) => link.classList.remove("active"));
    event.target.classList.toggle("active");

    //for the content under the navbar
    const contentPanel = document.getElementsByName("tabpanel");
    contentPanel.forEach((link) => {
      switch (event.currentTarget.id) {
        case "nav-link0":
          link.classList.remove("active");
          contentPanel[0].classList.add("active");
          break;
        case "nav-link1":
          link.classList.remove("active");
          contentPanel[1].classList.add("active");
          break;
        case "nav-link2":
          link.classList.remove("active");
          contentPanel[2].classList.add("active");

          break;
        case "nav-link3":
          link.classList.remove("active");
          contentPanel[3].classList.add("active");
          break;
        case "nav-link4":
          link.classList.remove("active");
          contentPanel[4].classList.add("active");
          break;
        default:
          break;
      }
      // link.classList.remove('active')
    });
  };

  console.log(LocationDropDown);
  return (
    <>
      <div className="Main_Dashboard">
        <div class="app-main__inner">
          <div class="row welcome-drop">
            <div class="col-lg-4 col-12">
              <h2 class="wlcm-head">
                Welcome <span>{fname}!</span>
              </h2>
            </div>
            <div class="col-lg-8 col-12">
              <div class="row top-sele-box">
                <div class="col-lg-4-col-12">
                  <div class="dt-sl">
                    <select
                      name="date"
                      id="date"
                      onChange={GetDate}
                      style={{ height: "38px" }}
                    >
                      <option value="this-week">This Week</option>
                      <option value="last-week">Last Week</option>
                      <option value="this-month">This Month</option>
                      <option value="last-month">Last Month</option>
                      <option value="this-year">This Year</option>
                      <option value="last-year">Last Year</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4-col-12">
                  <div class="lo-sl">
                    <Form.Group style={{ border: "none" }}>
                      <Select
                        id="LocationDropdown"
                        options={LocationDropDown.map((data) => ({
                          label: data.label,
                          value: data.value,
                        }))}
                        onChange={GetLocation}
                        value={Location}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: "none",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "black",
                            fontSize: "18px",
                          }),
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div class="col-lg-4-col-12">
                  <div class="stc-sl">
                    <select
                      name="civ"
                      id="civ"
                      onChange={chooseIV}
                      style={{ height: "38px" }}
                    >
                      <option value="">All Industries</option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Hospitality">Hospitality</option>
                      <option value="Education">Educational</option>
                      <option value="Corporate">Corporate</option>
                      <option value="Manufacturing">Manufacturing Unit</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" id="widget_Cards_header">
            <span>DEVICE STATUS</span>
          </div>
          <div>
            <span id="widget_Cards_top">Overview</span>
          </div>
          <div className="container">
            <div class="row" id="widget_Cards">
              <div class="col">
                <div class="card mb-6 widget-content bg-midnight-bloom">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading">
                        <img
                          src={require("../Components/assets/images/icons/total_devices.svg")}
                          alt=""
                        />
                        Total
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{Total}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-arielle-smile">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading">
                        <img
                          src={require("../Components/assets/images/icons/In_Stock.svg")}
                          alt=""
                        />
                        In Stock
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{InStock}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-grow-early">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading">
                        <img
                          src={require("../Components/assets/images/icons/In_Transit.svg")}
                          alt=""
                        />
                        In transit
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{inTransit}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-green-card">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading">
                        <img
                          src={require("../Components/assets/images/icons/Active.svg")}
                          alt=""
                        />{" "}
                        Active
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{Active}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-warning-card">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading">
                        <img
                          src={require("../Components/assets/images/icons/Damaged.svg")}
                          alt=""
                        />
                        Damaged
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{Damaged}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">
                    <i class="header-icon lnr-apartment icon-gradient bg-love-kiss">
                      {" "}
                    </i>
                    CUSTOMER RELATIONSHIP MANAGEMENT
                  </div>
                </div>
                <div class="card-body">
                  {/* <canvas id="bar-chart-grouped" class="crm-bar-cstm-styling" width="800" height="450"></canvas> */}
                  <Bar
                    id="bar-chart-grouped"
                    class="crm-bar-cstm-styling"
                    width="800"
                    height="380"
                    options={{
                      scales: {
                        xAxes: [
                          {
                            gridLines: {
                              display: false,
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: { stepSize: 1, beginAtZero: true },
                            gridLines: {
                              display: false,
                            },
                            gridLines: {
                              zeroLineWidth: 1,
                            },
                          },
                        ],
                      },
                      legend: {
                        display: true,
                        labels: {
                          usePointStyle: false,
                          boxWidth: 12,
                          fontSize: 15,
                        },
                        position: "bottom",
                      },
                    }}
                    data={CRMdata}
                  />
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-6">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">
                    <i class="header-icon lnr-apartment icon-gradient bg-love-kiss">
                      {" "}
                    </i>
                    INDUSTRY VERTICALS
                  </div>
                </div>
                <div class="card-body">
                  {/* <canvas id="horizontalBarChartCanvasIndustry" class="horizontal-bar-styling"></canvas> */}
                  <HorizontalBar
                    id="horizontalBarChartCanvasIndustry"
                    class="horizontal-bar-styling "
                    width="800"
                    height="380"
                    options={{
                      scales: {
                        xAxes: [
                          {
                            ticks: { stepSize: 1, beginAtZero: true },
                            gridLines: {
                              display: false,
                            },
                            gridLines: {
                              zeroLineWidth: 1,
                            },
                          },
                        ],
                        yAxes: [
                          {
                            gridLines: {
                              display: false,
                            },
                          },
                        ],
                      },
                      legend: {
                        display: false,
                      },
                    }}
                    data={IVdata}
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-12">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">
                    <i class="header-icon lnr-apartment icon-gradient bg-love-kiss">
                      {" "}
                    </i>
                    SUPPORT(Issues)
                  </div>
                </div>
                <div class="card-body">
                  <p class="sup-head-sec">Average Response Time(in min) : 30</p>
                  {/* <canvas id="support-hori-bar" class="support-bar-styling" data={StackedBarData} ></canvas> */}
                  <HorizontalBar
                    id="SUPPORT_Bar"
                    class="SUPPORT-bar-styling "
                    height={170}
                    data={SupportBarData}
                    options={SupportBaroptions}
                  />
                  <div class="v-all-btn">
                    <a href="/supports">
                      <u>View All</u>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-12">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">CUSTOMERS</div>
                </div>
                <div class="card-body">
                  <div class="scroll-area-sm">
                    <div class="">
                      <ul class="rm-list-borders rm-list-borders-scroll list-group list-group-flush">
                        {CUSTOMER.map((item) => (
                          <li class="list-group-item">
                            <div class="widget-content p-0">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left mr-3">
                                  <img
                                    width="42"
                                    class="rounded-circle"
                                    src="https://picsum.photos/300/300"
                                    alt=""
                                  />
                                </div>
                                <div class="widget-content-left">
                                  <div class="widget-heading">
                                    {item.userFirstName}
                                  </div>
                                  <div class="widget-subheading">
                                    {item.organization}
                                  </div>
                                </div>
                                <div class="widget-content-right">
                                  <div class="font-size-xlg text-muted">
                                    <span class="p-green">Paid</span>
                                    <small>
                                      {item.partner_details.userFirstName}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <div
                        className="v-all-btn"
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          paddingBottom: "30px",
                          paddingRight: "45px",
                        }}
                      >
                        <a href="/customers">
                          <u>View All</u>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-12">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">
                    <i class="header-icon lnr-apartment icon-gradient bg-love-kiss">
                      {" "}
                    </i>
                    SHIPMENT STATUS
                  </div>
                </div>
                <div class="card-body">
                  {/* <canvas id="horizontalBarChartCanvasShipment" class="horizontal-ship-bar-styling"></canvas> */}
                  <HorizontalBar
                    options={{
                      scales: {
                        xAxes: [
                          {
                            ticks: { stepSize: 1, beginAtZero: true },
                            gridLines: {
                              display: false,
                            },
                            gridLines: {
                              zeroLineWidth: 1,
                            },
                          },
                        ],
                        yAxes: [
                          {
                            gridLines: {
                              display: false,
                            },
                          },
                        ],
                      },
                      legend: {
                        display: false,
                      },
                    }}
                    data={ShipmentStatusData}
                    height={200}
                  />
                  <div class="v-all-btn">
                    <a href="/myshipments">
                      <u>View All</u>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5 col-12">
              <div class="mb-3 card h-100">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">SUPPORT TICKETS</div>
                </div>
                <div class="card-header">
                  <ul
                    class="nav nav-justified d-flex flex-nowrap"
                    id="scrollable-list"
                  >
                    <li class="nav-item">
                      <a
                        id="nav-link0"
                        data-toggle="tab"
                        class="nav-link active"
                        name="tabs"
                        onClick={handelClick}
                      >
                        All
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav-link1"
                        data-toggle="tab"
                        class="nav-link"
                        name="tabs"
                        onClick={handelClick}
                      >
                        Assigned
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav-link2"
                        data-toggle="tab"
                        class="nav-link"
                        name="tabs"
                        onClick={handelClick}
                      >
                        Solved
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav-link3"
                        data-toggle="tab"
                        class="nav-link"
                        name="tabs"
                        onClick={handelClick}
                      >
                        Pending
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav-link4"
                        data-toggle="tab"
                        class="nav-link"
                        name="tabs"
                        onClick={handelClick}
                      >
                        Escalation
                      </a>
                    </li>
                  </ul>
                </div>
                <div
                  class="card-body"
                  style={{
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <div class="scroll-area" style={{ height: "100%" }}>
                    <div class="tab-content">
                      <div
                        class="tab-pane active"
                        id="tab-eg7-0"
                        data-toggle="tab"
                        name="tabpanel"
                      >
                        <h2 class="st-main-head">{CurrentToggleDate}</h2>
                        <div
                          className="st-tab-list"
                          style={{ marginLeft: "15px" }}
                        >
                          <ul style={{ marginLeft: "10px" }}>
                            {SupportTicketAll.map((item, index) => (
                              <li style={{ listStyleType: "none" }}>
                                <ul class="queryContent">
                                  <li
                                    style={{
                                      marginLeft: "15px",
                                      listStyleType: "none",
                                    }}
                                  >
                                    <p>{item.description}</p>
                                  </li>
                                  <li
                                    className={
                                      index % 3 === 0
                                        ? "st-tab-li-coffe"
                                        : index % 3 === 1
                                        ? "st-tab-li-yellow"
                                        : "st-tab-li-aqua"
                                    }
                                    style={{
                                      marginLeft: "-35px",
                                      marginTop: "-13px",
                                      liststyletype: "none",
                                    }}
                                  >
                                    <span
                                      className="QuerySts"
                                      style={{ paddingLeft: "50px" }}
                                    >
                                      <b>{item.priority || "none"}</b> |
                                      Assigned to{" "}
                                      {item.userDetails &&
                                      item.userDetails.length === undefined
                                        ? item.userDetails.userFirstName
                                        : "none"}
                                    </span>
                                  </li>
                                </ul>
                              </li>
                            ))}
                          </ul>
                          <div
                            class="v-all-btn"
                            style={{
                              position: "absolute",
                              bottom: "20px",
                              right: "50px",
                            }}
                          >
                            <a href="/supports">
                              <u>View All</u>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        id="tab-eg7-1"
                        data-toggle="tab"
                        name="tabpanel"
                      >
                        <h2 class="st-main-head">{CurrentToggleDate}</h2>
                        <div
                          className="st-tab-list"
                          style={{ marginLeft: "10px" }}
                        >
                          <ul style={{ marginLeft: "10px" }}>
                            {SupportTicketAssigned.map((item, index) => (
                              <li style={{ listStyleType: "none" }}>
                                <ul class="queryContent">
                                  <li
                                    style={{
                                      marginLeft: "15px",
                                      listStyleType: "none",
                                    }}
                                  >
                                    <p>{item.description}</p>
                                  </li>
                                  <li
                                    className={
                                      index % 3 === 0
                                        ? "st-tab-li-coffe"
                                        : index % 3 === 1
                                        ? "st-tab-li-yellow"
                                        : "st-tab-li-aqua"
                                    }
                                    style={{
                                      marginLeft: "-35px",
                                      marginTop: "-13px",
                                      liststyletype: "none",
                                    }}
                                  >
                                    <span
                                      className="QuerySts"
                                      style={{ paddingLeft: "50px" }}
                                    >
                                      <b>{item.priority || "none"}</b> |
                                      Assigned to{" "}
                                      {item.userDetails &&
                                      item.userDetails.length === undefined
                                        ? item.userDetails.userFirstName
                                        : "none"}
                                    </span>
                                  </li>
                                </ul>
                              </li>
                            ))}
                          </ul>
                          <div
                            class="v-all-btn"
                            style={{
                              position: "absolute",
                              bottom: "20px",
                              right: "50px",
                            }}
                          >
                            <a href="/supports">
                              <u>View All</u>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        id="tab-eg7-2"
                        data-toggle="tab"
                        name="tabpanel"
                      >
                        <h2 class="st-main-head">{CurrentToggleDate}</h2>
                        <div
                          className="st-tab-list"
                          style={{ marginLeft: "10px" }}
                        >
                          <ul style={{ marginLeft: "10px" }}>
                            {SupportTicketSolved.map((item, index) => (
                              <li style={{ listStyleType: "none" }}>
                                <ul class="queryContent">
                                  <li
                                    style={{
                                      marginLeft: "15px",
                                      listStyleType: "none",
                                    }}
                                  >
                                    <p>{item.description}</p>
                                  </li>
                                  <li
                                    className={
                                      index % 3 === 0
                                        ? "st-tab-li-coffe"
                                        : index % 3 === 1
                                        ? "st-tab-li-yellow"
                                        : "st-tab-li-aqua"
                                    }
                                    style={{
                                      marginLeft: "-35px",
                                      marginTop: "-13px",
                                      liststyletype: "none",
                                    }}
                                  >
                                    <span
                                      className="QuerySts"
                                      style={{ paddingLeft: "50px" }}
                                    >
                                      <b>{item.priority || "none"}</b> |
                                      Assigned to{" "}
                                      {item.userDetails &&
                                      item.userDetails.length === undefined
                                        ? item.userDetails.userFirstName
                                        : "none"}
                                    </span>
                                  </li>
                                </ul>
                              </li>
                            ))}
                          </ul>
                          <div
                            class="v-all-btn"
                            style={{
                              position: "absolute",
                              bottom: "20px",
                              right: "50px",
                            }}
                          >
                            <a href="/supports">
                              <u>View All</u>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        id="tab-eg7-3"
                        data-toggle="tab"
                        name="tabpanel"
                      >
                        <h2 class="st-main-head">{CurrentToggleDate}</h2>
                        <div
                          className="st-tab-list"
                          style={{ marginLeft: "10px" }}
                        >
                          <ul style={{ marginLeft: "10px" }}>
                            {SupportTicketPending.map((item, index) => (
                              <li style={{ listStyleType: "none" }}>
                                <ul class="queryContent">
                                  <li
                                    style={{
                                      marginLeft: "15px",
                                      listStyleType: "none",
                                    }}
                                  >
                                    <p>{item.description}</p>
                                  </li>
                                  <li
                                    className={
                                      index % 3 === 0
                                        ? "st-tab-li-coffe"
                                        : index % 3 === 1
                                        ? "st-tab-li-yellow"
                                        : "st-tab-li-aqua"
                                    }
                                    style={{
                                      marginLeft: "-35px",
                                      marginTop: "-13px",
                                      liststyletype: "none",
                                    }}
                                  >
                                    <span
                                      className="QuerySts"
                                      style={{ paddingLeft: "50px" }}
                                    >
                                      <b>{item.priority || "none"}</b> |
                                      Assigned to{" "}
                                      {item.userDetails &&
                                      item.userDetails.length === undefined
                                        ? item.userDetails.userFirstName
                                        : "none"}
                                    </span>
                                  </li>
                                </ul>
                              </li>
                            ))}
                          </ul>
                          <div
                            class="v-all-btn"
                            style={{
                              position: "absolute",
                              bottom: "20px",
                              right: "50px",
                            }}
                          >
                            <a href="/supports">
                              <u>View All</u>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        id="tab-eg7-4"
                        data-toggle="tab"
                        name="tabpanel"
                      >
                        <h2 class="st-main-head">{CurrentToggleDate}</h2>
                        <div
                          className="st-tab-list"
                          style={{ marginLeft: "15px" }}
                        >
                          <ul style={{ marginLeft: "10px" }}>
                            {SupportTicketEscalation.map(
                              (SupportItem, SupportIndex) => (
                                <li
                                  style={{ listStyleType: "none" }}
                                  key={SupportIndex}
                                >
                                  <ul className="queryContent">
                                    <li
                                      style={{
                                        marginLeft: "15px",
                                        listStyleType: "none",
                                      }}
                                    >
                                      <p>{SupportItem.description}</p>
                                    </li>
                                    <li
                                      className={
                                        SupportIndex % 3 === 0
                                          ? "st-tab-li-coffe"
                                          : SupportIndex % 3 === 1
                                          ? "st-tab-li-yellow"
                                          : "st-tab-li-aqua"
                                      }
                                      style={{
                                        marginLeft: "-35px",
                                        marginTop: "-13px",
                                        listStyleType: "none",
                                      }}
                                    >
                                      <span
                                        className="QuerySts"
                                        style={{ paddingLeft: "50px" }}
                                      >
                                        <b>{SupportItem.priority || "none"}</b>{" "}
                                        | Assigned to{" "}
                                        {SupportItem.userDetails &&
                                        SupportItem.userDetails.length ===
                                          undefined
                                          ? SupportItem.userDetails
                                              .userFirstName
                                          : "none"}
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                              )
                            )}
                          </ul>
                          <div
                            class="v-all-btn"
                            style={{
                              position: "absolute",
                              bottom: "20px",
                              right: "50px",
                            }}
                          >
                            <a href="/supports">
                              <u>View All</u>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 col-12">
              <div class="main-card mb-3 card h-100">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title">MAP VIEW</div>
                  <div class="card-header-info">
                    <div class="active-devices">
                      Total Active Devices : {Active}
                    </div>
                    <div class="inactive-devices">
                      Total Inactive Devices : {Damaged}
                      {/* Here Inactive Devices are damaged Devices . */}
                    </div>
                  </div>
                </div>
                <div
                  class="card-body"
                  style={{ height: "100%", position: "relative" }}
                >
                  <div class="gmap-cstm-styling" style={{ height: "100%" }}>
                    <GoogleMapReact
                      style={{
                        position: "absolute",
                        top: 20,
                        left: 20,
                        right: 20,
                        bottom: 20,
                        overflow: "hidden",
                      }}
                      defaultCenter={{ lat: 20.2961, lng: 85.8245 }}
                      defaultZoom={10}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SysAdminDashboard;
